import Vue from 'vue'

// axios
import axios from '@axios'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'

// copy axios object

const axiosIns = { ...axios }

axiosIns.defaults.withCredentials = true

axiosIns.interceptors.response.use(
  response => response,
  error => {
    console.log('error', { ...error })
    const status = error.response ? error.response.status : null

    if (!status) {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: 'Server error',
          icon: 'BellIcon',
          variant: 'danger',
        },
      })
    } else {
      // skip wrong stats error
      if (error.response.data.message === 'Undefined array key "size"') {
        return Promise.reject(error)
      }

      // router error, show different toast message
      if (status === 512) {
        if (process.env.VUE_APP_ENV === 'stage') {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.message,
              icon: 'HardDriveIcon',
              variant: 'warning',
            },
          })
        } else {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Oops! Something went wrong, please contact your supplier if the issue persists.',
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        }
        throw error
      } else {
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: error.response.data.message,
            icon: 'BellIcon',
            variant: 'error',
          },
        })
      }
    }

    throw error
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
